import { MenuModel } from "../models/menu.model";

export const Menu: MenuModel[] = [

  {
    title: "Dashboard",
    route: "",
    frame: "DASHBOARD_ONE",
    order: 1,
    icon: "home",
    subMenu: [
      {
        title: "General Dashboard",
        route: "/dashboard/gender",
        frame: "DASHBOARD_ONE",
        order: 1,
        icon: "",
      },
      {
        title: "Complaint Dashboard",
        route: "/dashboard/complaints",
        frame: "DASHBOARD_ONE",
        order: 2,
        icon: "",
      },
      {
        title: "Response Dashboard",
        route: "/dashboard/csr",
        frame: "DASHBOARD_ONE",
        order: 3,
        icon: "",
      },
      {
        title: "Dynamic Dashboard",
        route: "/dynamic-dashboard/v2",
        frame: "DASHBOARD_ONE",
        order: 4,
        icon: "",
      },
    ],
  },
  {
    title: "DPC Report",
    route: "/dashboard/delay-complaints",
    frame: "DELAY_WISE_REPORT",
    order: 2,
    icon: "bar_chart",
  },
  {
    title: "Complaints",
    route: "/complaint",
    frame: "COMPLAINT",
    order: 3,
    icon: "home",
  },
  {
    title: "Groups",
    route: "",
    frame: "GROUPS",
    icon: "group",
    order: 4,
    subMenu: [
      {
        title: "Groups",
        route: "/groups",
        frame: "GROUPS",
        order: 1,
        icon: "group",
      },
      // {
      //     title: 'User Groups',
      //     route: '/groups/user-groups',
      //     frame: 'GROUPS',
      //     order: 2,
      //     icon: 'group'
      // },
      {
        title: "Group Rights",
        route: "/groups/group-rights",
        frame: "GROUPS",
        order: 3,
        icon: "group",
      },
      {
        title: "Group Users",
        route: "/groups/group-users",
        frame: "GROUPS",
        order: 4,
        icon: "group",
      },
      {
        title: "User Rights",
        route: "/groups/user-rights",
        frame: "GROUPS",
        order: 5,
        icon: "group",
      },
    ],
  },
  {
    title: "Complaint Setup",
    route: "",
    icon: "timeline",
    frame: "COMPLAINT_CATEGORY",
    order: 5,
    subMenu: [
      {
        title: "Complainant type",
        route: "/complaint-category/complaint-type",
        frame: "COMPLAINT_CATEGORY",
        order: 1,
        icon: "add_circle_outline",
      },
      {
        title: "Complaint type",
        route: "/complaint-category/complaint-subtype",
        frame: "COMPLAINT_CATEGORY",
        order: 2,
        icon: "add_circle_outline",
      },
    ],
  },
  {
    title: "Status",
    route: "/work-flow-steps",
    icon: "timeline",
    frame: "COMPLAINT_PROCESS",
    order: 6,
  },
  {
    title: "Regions",
    route: "",
    icon: "place",
    frame: "ADMIN_STRUCTURE",
    order: 7,
    subMenu: [
      {
        title: "Division",
        route: "/region/division",
        frame: "ADMIN_STRUCTURE",
        order: 1,
        icon: "place",
      },
      {
        title: "District",
        route: "/region/district",
        frame: "ADMIN_STRUCTURE",
        order: 2,
        icon: "place",
      },
      {
        title: "Tehsil",
        route: "/region/tehsil",
        frame: "ADMIN_STRUCTURE",
        order: 3,
        icon: "place",
      },
      {
        title: "Mouza",
        route: "/region/mouza",
        frame: "ADMIN_STRUCTURE",
        order: 4,
        icon: "place",
      },
    ],
  },
  {
    title: "User Management",
    route: "/user",
    frame: "USER",
    order: 8,
    icon: "person_add",
  },
  {
    title: "SMS Activity",
    route: "/sms-tracking",
    frame: "SMS_USAGE_TRACKING",
    order: 9,
    icon: "sms",
  },
  {
    title: "WhatsApp",
    route: "",
    frame: "WHATSAPP_LOGS_SCREEN",
    order: 10,
    icon: "chat",
    subMenu: [
      {
        title: "Conversations",
        route: "/whatsapp-log-screen",
        frame: "WHATSAPP_LOGS_SCREEN",
        order: 1,
        icon: "",
      },
      {
        title: "AI Agent Conversations",
        route: "/whatsapp-ai-agent-conversations",
        frame: "WHATSAPP_LOGS_SCREEN",
        order: 2,
        icon: "",
      },
    ],
  },
  {
    title: "Email",
    route: "",
    frame: "EMAIL_MANAGEMENT",
    order: 11,
    icon: "email",
    subMenu: [
      {
        title: "Email Complaints",
        route: "/email-complaints",
        frame: "EMAIL_MANAGEMENT",
        order: 1,
        icon: "",
      },
    ],
  },
  {
    title: "Citizen Chatbot",
    route: "",
    frame: "CHATBOT_DASHBOARD",
    order: 12,
    icon: "smart_toy",
    subMenu: [
      {
        title: "Training Data",
        route: "/citizen-chatbot/queries",
        frame: "CHATBOT_DASHBOARD",
        order: 1,
        icon: "",
      },
      {
        title: "Training History",
        route: "/citizen-chatbot/training-history",
        frame: "CHATBOT_DASHBOARD",
        order: 2,
        icon: "",
      },
      {
        title: "Chat History",
        route: "/citizen-chatbot/chat-logs",
        frame: "CHATBOT_DASHBOARD",
        order: 3,
        icon: "",
      },
      {
        title: "Failed Responses",
        route: "/citizen-chatbot/failed-queries",
        frame: "CHATBOT_DASHBOARD",
        order: 4,
        icon: "",
      },
      {
        title: "Complaint Assist Logs",
        route: "/citizen-chatbot/complaint-assist",
        frame: "CHATBOT_DASHBOARD",
        order: 5,
        icon: "",
      },
      {
        title: "Website Knowledge Crawler",
        route: "/citizen-chatbot/website-urls",
        frame: "CHATBOT_DASHBOARD",
        order: 6,
        icon: "",
      },
    ],
  },
  {
    title: "Internal Chatbot",
    route: "",
    frame: "CHATBOT_DASHBOARD",
    order: 13,
    icon: "support_agent",
    subMenu: [
      {
        title: "Documents",
        route: "/internal-chatbot/documents",
        frame: "CHATBOT_DASHBOARD",
        order: 1,
        icon: "",
      },
      {
        title: "Documents History",
        route: "/internal-chatbot/documents-history",
        frame: "CHATBOT_DASHBOARD",
        order: 2,
        icon: "",
      },
      {
        title: "Chat Logs",
        route: "/internal-chatbot/chat-logs",
        frame: "CHATBOT_DASHBOARD",
        order: 3,
        icon: "",
      },
    ],
  },
  {
    title: "Social Media",
    route: "",
    frame: "SOCIAL_MEDIA",
    order: 14,
    icon: "public",
    subMenu: [
      {
        title: "Facebook",
        route: "/social-media/facebook",
        frame: "SOCIAL_MEDIA",
        order: 1,
        icon: "",
      },
      {
        title: "Instagram",
        route: "/social-media/instagram",
        frame: "SOCIAL_MEDIA",
        order: 2,
        icon: "",
      },
      {
        title: "YouTube Monitoring",
        route: "/social-media/youtube-monitoring",
        frame: "SOCIAL_MEDIA",
        order: 3,
        icon: "",
      },
    ],
  },
  {
    title: "Contact Center",
    route: "/telephony",
    frame: "CSR_CONSOLE",
    order: 15,
    icon: "headset_mic",
    subMenu: [
      {
        title: "Agent Console",
        route: "/telephony",
        frame: "CSR_CONSOLE",
        order: 1,
        icon: "",
      },
      {
        title: "Social Media Comments",
        route: "/omnichannel/inbox",
        frame: "CSR_CONSOLE",
        order: 2,
        icon: "",
      },
      {
        title: "Telephony Messages",
        route: "/telephony/messages",
        frame: "CSR_CONSOLE",
        order: 3,
        icon: "",
      },
      {
        title: "Call History",
        route: "/telephony/history",
        frame: "CSR_HISTORY",
        order: 5,
        icon: "",
      },
      {
        title: "Extension Status",
        route: "/telephony/extensions",
        frame: "CSR_CONSOLE",
        order: 6,
        icon: "",
      },
    ],
  },
  {
    title: "Supervisor",
    route: "",
    frame: "SUPERVISOR",
    order: 16,
    icon: "supervisor_account",
    subMenu: [
      {
        title: "Control Room",
        route: "/telephony/supervisor/control-room",
        frame: "SUPERVISOR",
        order: 1,
        icon: "",
      },
      {
        title: "Agent Wallboard",
        route: "/telephony/supervisor/wallboard",
        frame: "SUPERVISOR",
        order: 2,
        icon: "",
      },
      {
        title: "Queue Monitor",
        route: "/telephony/supervisor/queue-monitor",
        frame: "SUPERVISOR",
        order: 3,
        icon: "",
      },
      {
        title: "IVR Voice Complaints",
        route: "/telephony/supervisor/ivr-submissions",
        frame: "IVR_VOICE_COMPLAINTS",
        order: 4,
        icon: "",
      },
      {
        title: "Callback Worklist",
        route: "/telephony/supervisor/callbacks",
        frame: "SUPERVISOR",
        order: 5,
        icon: "",
      },
      {
        title: "Operational Analytics",
        route: "/telephony/supervisor/operational-report",
        frame: "SUPERVISOR",
        order: 6,
        icon: "",
      },
      {
        title: "Live Chat Monitor",
        route: "/telephony/supervisor/live-chats",
        frame: "SUPERVISOR",
        order: 7,
        icon: "",
      },
    ],
  },
  {
    title: "Reliability",
    route: "/reliability",
    frame: "RELIABILITY_DASHBOARD",
    order: 17,
    icon: "monitor_heart",
  },
  {
    title: "Administration",
    route: "",
    frame: "USER",
    order: 18,
    icon: "admin_panel_settings",
    subMenu: [
      {
        title: "Applications",
        route: "/administration/applications",
        frame: "USER",
        order: 1,
        icon: "apps",
      },
      {
        title: "NMS Multi-Agent",
        route: "/administration/nms-multi-agent",
        frame: "USER",
        order: 2,
        icon: "hub",
      },
    ],
  },
  {
    title: "AI Control Center",
    route: "",
    frame: "USER",
    order: 18.5,
    icon: "policy",
    subMenu: [
      {
        title: "Converse Governance",
        route: "/ai-control/converse/overview",
        frame: "USER",
        order: 1,
        icon: "",
      },
    ],
  },
  {
    title: "R&D",
    route: "",
    frame: "RND",
    order: 19,
    icon: "science",
    subMenu: [
      {
        title: "AI Dashboard",
        route: "/rnd/dashboard",
        frame: "RND",
        order: 1,
        icon: "",
      },
      {
        title: "Voice Transcription",
        route: "/rnd/voice-transcription",
        frame: "RND",
        order: 2,
        icon: "",
      },
      {
        title: "Text to Speech",
        route: "/rnd/text-to-speech",
        frame: "RND",
        order: 3,
        icon: "",
      },
      {
        title: "Piper Voice Lab",
        route: "/rnd/piper-tts",
        frame: "RND",
        order: 3.25,
        icon: "",
      },
      {
        title: "Urdu XTTS Voice Lab",
        route: "/rnd/xtts-urdu",
        frame: "RND",
        order: 3.5,
        icon: "",
      },
      {
        title: "Gemma Voice Function",
        route: "/rnd/gemma-voice-function",
        frame: "RND",
        order: 4,
        icon: "",
      },
      {
        title: "Option 4 · Honcho Memory",
        route: "/rnd/ivr-memory",
        frame: "RND",
        order: 4.1,
        icon: "",
      },
      {
        title: "AI Admin Assistant",
        route: "/rnd/ai-admin-assistant",
        frame: "RND",
        order: 5,
        icon: "",
      },
      {
        title: "Whisper Benchmark",
        route: "/rnd/whisper-benchmark",
        frame: "RND",
        order: 6,
        icon: "",
      },
      {
        title: "Context Agent Lab",
        route: "/rnd/context-agent-lab",
        frame: "CONTEXT_AGENT_LAB",
        order: 7,
        icon: "",
      },
      {
        title: "AI Call Simulator",
        route: "/rnd/ai-call-simulator",
        frame: "RND",
        order: 8,
        icon: "",
      },
      {
        title: "Pashto & Dari Speech Lab",
        route: "/rnd/pashto-dari-speech",
        frame: "RND",
        order: 9,
        icon: "",
      },
    ],
  },
];
